import {
    STATE_NOT_DEFINED,
} from '@/components/venue_items/states';

// eslint-disable-next-line
export const items = state => state.items || {};

// eslint-disable-next-line
export const map = state => state.map || '';

// eslint-disable-next-line
export const getItemState = (state) => {
    return (vsid) => {
        if (state.items && state.items[vsid]) {
            return state.items[vsid].state;
        }

        return STATE_NOT_DEFINED;
    };
};

/* export const itemAppearance = (state) => {
    return (vsid) => {
        if (state.items && state.items[vsid]) {
            return state.items[vsid].state;
        }

        return STATE_NOT_DEFINED;
    };
};

export const itemSelected = (state) => {
    return (vsid) => {
        if (state.items && state.items[vsid] && state.items[vsid].selected) {
            return state.items[vsid].selected;
        }

        return false;
    };
}; */

export const itemState = state => (vsid) => {
    const iState = {};

    if (state.items[vsid] && state.items[vsid].state) {
        iState.appearance = state.items[vsid].state;
    } else {
        iState.appearance = STATE_NOT_DEFINED;
    }

    if (state.items[vsid] && state.items[vsid].selected) {
        iState.selected = state.items[vsid].selected;
    } else {
        iState.selected = false;
    }

    if (state.items[vsid] && typeof state.items[vsid].success !== 'undefined') {
        iState.success = state.items[vsid].success;
    } else {
        iState.success = true;
    }

    return iState;
};

// export const getInspectedSeat = state => state.seatData.inspectedSeat;

export const itemData = state => (vsid) => {
    if (typeof state.items[vsid] === 'undefined') {
        // TODO: fallback item visszaadasa helyett inkabb a prop validaciok modositasa kene
        // a SeatInfoTooltipContent-ben es a TicketListItem-ben
        return {
            adminFee: 0,
            currency: '',
            id: '',
            productType: '',
            name: '',
            price: 0,
            pricePercentage: 0,
            product: '',
            row: 0,
            sector: '',
            state: STATE_NOT_DEFINED,
            ticketName: '',
            type: 'seat',
            vsid,
        };
    }

    const item = {
        vsid,
        ...state.items[vsid],
    };

    if (typeof state.items[vsid].product !== 'undefined') {
        const product = state.products[state.items[vsid].product];

        if (product) {
            // TODO: inkabb productName-nek kene hivni (vagy meg inkabb productInfonak)
            item.ticketName = state.products[state.items[vsid].product]
                ? state.products[state.items[vsid].product].name : '';
            const adminFeeProduct = product.adminFee && state.products[product.adminFee] ?
                state.products[product.adminFee] :
                null;
            if (adminFeeProduct && adminFeeProduct.productType === 'percentbasedadminfeeproduct' && adminFeeProduct.pricePercentage) {
                item.adminFee = product.price * adminFeeProduct.pricePercentage;

                if (typeof product.maxFractionDigit !== 'undefined') {
                    item.adminFee = parseFloat(item.adminFee.toFixed(product.maxFractionDigit), 10);
                }
            } else {
                item.adminFee = adminFeeProduct
                    ? adminFeeProduct.price : 0;
            }
            item.price = product.price;
            item.currency = product.currency;
        }
    }

    return item;
};

export const loading = state => state.loading;

export const errorMessage = state => state.errorMessage;

export const redirectTo = state => state.redirectTo;

export const selectedTickets = state => state.selectedTickets;

export const selectedTicketsPacked = (state) => {
    const pack = {};

    state.selectedTickets.forEach((elem) => {
        if (pack[elem.vsid]) {
            pack[elem.vsid].quantity += 1;
        } else {
            pack[elem.vsid] = {
                quantity: 1,
                assignmentId: state.items[elem.vsid].assignmentId,
            };
        }
    });

    return pack;
};

export const eventCode = state => state.eventCode || '';

export const totalPrice = (state, getters) => {
    let price = 0;

    state.selectedTickets.forEach((i) => {
        const item = getters.itemData(i.vsid);

        price += item.price + item.adminFee;
    });

    return price;
};

export const currency = (state, getters) => {
    if (state.selectedTickets[0]) {
        return getters.itemData(state.selectedTickets[0].vsid).currency;
    }

    return '';
};

export const numSelectedTickets = state => state.selectedTickets.length;

export const products = (state) => {
    const keys = Object.keys(state.products);
    const retval = [];

    keys.forEach((key) => {
        retval.push({
            productId: key,
            ...state.products[key],
        });
    });

    return retval;
};

export const selectedItemsForEditing = (state) => {
    const selectedItems = [];
    const keys = Object.keys(state.items);

    keys.forEach((vsid) => {
        if (state.items[vsid].selected === true) {
            selectedItems.push(vsid);
        }
    });

    return selectedItems;
};

export const numSelectedItemsForEditing =
    (state, getters) => getters.selectedItemsForEditing.length;

export const numAssignmentsInSelection = (state, getters) => {
    const selectedItems = getters.selectedItemsForEditing;
    let numAssignments = 0;

    selectedItems.forEach((vsid) => {
        if (state.items[vsid].assignmentId && state.items[vsid].assignmentId !== '') {
            numAssignments += 1;
        }
    });

    return numAssignments;
};

export const isTicketStoreMobileActive = state => state.isTicketStoreMobileActive;

export const hasAdminFee = (state) => {
    let retval = false;
    const prods = Object.keys(state.products);

    prods.forEach((prodId) => {
        if (
            state.products[prodId].adminFee &&
            typeof state.products[state.products[prodId].adminFee] !== 'undefined' &&
            state.products[state.products[prodId].adminFee].price > 0
        ) {
            retval = true;
        }
    });

    return retval;
};

export const marketingTitle = state => state.marketingTitle;

export const eventName = state => state.eventName.replace(/&amp;/g, '&');

export const bookingLayerVisible = state => state.bookingLayerVisible;



// WEBPACK FOOTER //
// ./src/vuex/modules/booking/getters.js